import * as actionConsts from './actions';
import update from 'react/lib/update';
import * as dailyReportActionConsts from '../actions';

export const initState = {
  employees: [],
  registeredEmployees: [],
  checkInCheckOutMode: true,
}


export default (state = initState, action) => {
  switch (action.type) {
    case dailyReportActionConsts.DAILY_REPORT_GET_SUCCESS:
      return update(state, {
        employees: {
          $set: action.employees
        },
        registeredEmployees: {
          $set: action.registeredEmployees
        },
        checkInCheckOutMode: {
          $set: action.checkInCheckOutMode,
        }
      });
    case dailyReportActionConsts.WORKPLACE_ADD_EMPLOYEE_REQUEST:
      return update(state, {
        employees: {
          $splice: [[0, 0, action.employee]]
        }
      });
    case dailyReportActionConsts.REMOVE_EMPLOYEE_FROM_WORKPLACE_2:
      return update(state, {
        employees: {
          $splice: [[action.employeeIndex, 1]]
        }
      });
    case actionConsts.DAILY_REPORT_SET_EMPLOYEE_ABSENCE:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            absence: {
              $set: action.absence
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_REMOVE_EMPLOYEE_ABSENCE:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            absence: {
              $set: null
            }
          }
        }
      });
    case actionConsts.EMPLOYEE_BREAK:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            break: {
              $set: action.break
            }
          }
        }
      })
    case actionConsts.DAILY_REPORT_TOGGLE_SHACK:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            shack: {
              $set: action.shack
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_SET_MILEAGE:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            mileage: {
              $set: action.mileage
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_EMPLOYEE_TIME_REGISTRATION:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            timeRegistrations: {
              [action.timeRegistrationIndex]: {
                [action.typeOf]: {
                  $set: action.val
                }
              }
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_EMPLOYEE_ADD_TIME_REGISTRATION:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            timeRegistrations: {
              $push: [action.timeRegistration]
            }
          }
        }
      });
    case actionConsts.DAILY_REPORT_EMPLOYEE_UPDATE_TIME_REGISTRATIONS:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            timeRegistrations: {
              $set: action.timeRegistrations
            }
          }
        }
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Employees/reducer.js